"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectListFieldView = void 0;
const multi_list_input_1 = require("../../../components/input/multi.list.input");
const select_list_chooser_state_1 = require("../../multi.list.chooser/select.list.chooser.state");
exports.SelectListFieldView = {
    viewInline(field) {
        return field.hasValue() ? field.displayValue : null;
    },
    viewDetail(field) {
        return null;
    },
    viewEdit(field, ctrl) {
        let inputState = ctrl.changeState.getState(field.id);
        if (inputState == null) {
            inputState = new select_list_chooser_state_1.SelectListChooserState(field);
            inputState.onValue(() => setManualValue(field, inputState));
            ctrl.changeState.addState(field.id, inputState);
        }
        return multi_list_input_1.MultiListInput.view(inputState);
    }
};
function setManualValue(field, inputState) {
    const value = inputState.value;
    if (value != null) {
        field.Mutator.manual(value[0]);
    }
    else {
        field.Mutator.clear();
    }
}
//# sourceMappingURL=select.list.field.view.js.map